import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { InfoIcon } from '../../../../assets/icons';
import { getBeutifiedText } from 'utils';
import useTranslation from 'hooks/useTranslation';

import './styles.scss';

const OperatorItem = ({
  operator,
  id,
  fullName,
  imageUrl,
  averageTime,
  accepted, //! metrics
  totalWorkTime,
  responseTimeAverage, //! metrics
  conversationTimeAverage, //! metrics
  csPercent, //! metrics
  score,
}) => {
  const { getTranslation } = useTranslation('STATISTICS');
  const { t } = getTranslation();

  // const [activityData, setActivityData] = useState();

  // const getActivityData = (statistic) => {
  //   let totalDailyActivity = {
  //     hour: 0,
  //     minute: 0,
  //   };

  //   let averageActivity = {
  //     hour: 0,
  //     minute: 0,
  //   };

  //   let chats = 0;

  //   if (Array.isArray(statistic) && statistic.length > 0) {
  //     statistic.forEach((item) => {
  //       totalDailyActivity.hour += item.dailyActivity.hour;

  //       totalDailyActivity.minute += item.dailyActivity.minute;

  //       chats += item.dailyAcceptedChats;
  //     });

  //     if (totalDailyActivity.minute >= 60) {
  //       totalDailyActivity.hour += parseInt(totalDailyActivity.minute / 60);
  //       totalDailyActivity.minute = parseInt(totalDailyActivity.minute % 60);
  //     }

  //     let totalMinute =
  //       totalDailyActivity.hour * 60 + totalDailyActivity.minute;
  //     let averageMinute = totalMinute / statistic.length;
  //     averageActivity.minute = Math.round(averageMinute);

  //     if (averageActivity.minute >= 60) {
  //       averageActivity.hour += parseInt(averageActivity.minute / 60);
  //       averageActivity.minute = parseInt(averageActivity.minute % 60);
  //     }

  //     setActivityData({
  //       totalDailyActivity,
  //       averageActivity,
  //       chats: chats,
  //     });
  //   } else {
  //     setActivityData({
  //       totalDailyActivity: {
  //         hour: 0,
  //         minute: 0,
  //       },
  //       averageActivity: {
  //         hour: 0,
  //         minute: 0,
  //       },
  //       chats: 0,
  //     });
  //   }
  // };

  // useEffect(() => {
  //   getActivityData(activityStatistics);
  // }, [activityStatistics]);

  return (
    <tr className='row operator'>
      <td>
        <div className='general-info-container'>
          {imageUrl && (
            <div>
              <div className='image-container'>
                {<img className='image' src={imageUrl} alt='' />}
              </div>
            </div>
          )}

          <span>{getBeutifiedText(fullName, 20, true)}</span>
        </div>
      </td>
      <td>{totalWorkTime}</td>
      <td>{averageTime}</td>
      <td>
        {accepted}
        {` ${t('OPERATORS_STATISTICS_TABLE_ACCEPTED_COL_PREFIX')}`}
      </td>
      <td>{responseTimeAverage}</td>
      <td>{conversationTimeAverage}</td>
      <td>{csPercent}</td>
      <td className='score'>{score}</td>

      <td className='info-wrapper'>
        {id ? (
          <Link to={`/reports/operators/${id}`}>
            <img className='info-icon' src={InfoIcon} alt='' />
          </Link>
        ) : (
          '-'
        )}
      </td>
    </tr>
  );
};

OperatorItem.propTypes = {
  id: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  averageTime: PropTypes.string.isRequired,
  accepted: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalWorkTime: PropTypes.string.isRequired,
  responseTimeAverage: PropTypes.string.isRequired,
  conversationTimeAverage: PropTypes.string.isRequired,
  csPercent: PropTypes.number.isRequired,
  score: PropTypes.string.isRequired,
};

export default OperatorItem;
